(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mlf-size-selector')) {
    class MlfSizeSelector extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', this.updateFields);
        this.addEventListener('input', this.updateFields);
        this.updateFields();
      }
      disconnectedCallback() {
        this.removeEventListener('change', this.updateFields);
        this.removeEventListener('input', this.updateFields);
      }
      updateFields = () => {
        const select = this.querySelector('select');
        const other = this.querySelector('input');
        const wrap = this.querySelector('[data-mlf-other-wrap]');
        if (!select || !other || !wrap) return;
        const needsOther = select.value === 'Other size';
        wrap.hidden = !needsOther;
        other.disabled = !needsOther;
        other.required = needsOther;
        other.setCustomValidity(needsOther && !other.value.trim() ? 'Please enter your preferred size.' : '');
        const accelerated = this.closest('form')?.querySelector('[data-mlf-accelerated]');
        if (accelerated) accelerated.hidden = !select.value || (needsOther && !other.value.trim());
      };
    }
    customElements.define('mlf-size-selector', MlfSizeSelector);
  }
  } catch(e) { console.error(e); }
})();

})();
